import { useState, useEffect } from 'react';
import { adminGet } from '../lib/api';

export function VoiceAnalytics() {
  const [data, setData] = useState<{ status: string; message: string; metrics: { totalConversations: number; avgDuration: number } } | null>(null);

  useEffect(() => {
    (async () => {
      const resp = await adminGet('/api/admin/voice-analytics');
      if (resp.ok && resp.data) setData(resp.data as typeof data);
    })();
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-display font-bold text-white mb-6">Voice Analytics</h1>

      <div className="bg-dark-700 rounded-2xl border border-dark-650/50 p-12 text-center">
        <span className="material-symbols-outlined text-5xl text-dark-500 mb-4 block">mic</span>
        <h2 className="text-xl font-display font-bold text-white mb-2">Coming Post-PEAK</h2>
        <p className="text-sm text-dark-400 max-w-md mx-auto leading-relaxed">
          Voice analytics will be available when the TattleBot voice pipeline is in production.
          This panel will show conversation logs, transcripts, duration metrics, topic distribution,
          and satisfaction signals.
        </p>

        {data && (
          <div className="mt-6 grid grid-cols-2 gap-4 max-w-xs mx-auto">
            <div className="bg-dark-800 rounded-xl p-4">
              <p className="text-2xl font-display font-bold text-white">{data.metrics.totalConversations}</p>
              <p className="text-xs text-dark-400">Conversations</p>
            </div>
            <div className="bg-dark-800 rounded-xl p-4">
              <p className="text-2xl font-display font-bold text-white">{data.metrics.avgDuration}s</p>
              <p className="text-xs text-dark-400">Avg Duration</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
